import script from "./DocumentLineDelete.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentLineDelete.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentLineDelete.vue?vue&type=style&index=0&id=190ffd39&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190ffd39"]])

export default __exports__